import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import LocationSelection from '../views/location-selection/LocationSelection.vue'
import ProviderSelection from '../views/provider-selection/ProviderSelection.vue'
import PatientDetails from '../views/patient-details/PatientDetails.vue'
import Recommend from '../views/recommend/Recommend.vue'
import ReviewDestination from '../views/review-destination/ReviewDestination.vue'
import FeedbackForm from '../views/feedback-form/FeedbackForm.vue'
import Confirmation from '../views/confirmation/Confirmation.vue'

Vue.use(VueRouter)

// Vue Router 3 rejects duplicate, cancelled, and redirected navigations.
// Call sites that don't await those promises become unhandled rejections,
// which Cypress fails as application errors.
function ignoreNavigationFailure (original) {
  return function navigate (location, onComplete, onAbort) {
    if (onComplete || onAbort) return original.call(this, location, onComplete, onAbort)
    return original.call(this, location).catch(err => {
      if (VueRouter.isNavigationFailure(err)) return err
      throw err
    })
  }
}

VueRouter.prototype.push = ignoreNavigationFailure(VueRouter.prototype.push)
VueRouter.prototype.replace = ignoreNavigationFailure(VueRouter.prototype.replace)

const routes = [
  {
    path: '/',
    redirect: to => ({ path: '/location-selection', query: to.query })
  },
  {
    path: '/location-selection',
    name: 'LocationSelection',
    component: LocationSelection
  },
  {
    path: '/provider-selection',
    name: 'ProviderSelection',
    component: ProviderSelection
  },
  {
    path: '/patient-details',
    name: 'PatientDetails',
    component: PatientDetails
  },
  {
    path: '/recommend',
    name: 'Recommend',
    component: Recommend
  },
  {
    path: '/review-destination',
    name: 'ReviewDestination',
    component: ReviewDestination
  },
  {
    path: '/feedback-form',
    name: 'FeedbackForm',
    component: FeedbackForm
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

function hasPatientInfo () {
  const info = store.getters['reputation/patientInfo'] || {}
  return Boolean(info.firstName && info.lastName && info.email)
}

// A campaign or appointment id is stored first as a stub with an empty
// locationId. That stub is not a selected office: LocationSelection has to
// resolve it before a later step can load providers or submit a review.
function hasResolvedLocation () {
  const location = store.getters['reputation/selectedLocation']
  return Boolean(location && location.locationId)
}

const GUARD_RULES = [
  {
    routes: ['ProviderSelection', 'PatientDetails', 'Recommend', 'ReviewDestination', 'FeedbackForm'],
    redirectTo: 'LocationSelection',
    condition: () => !hasResolvedLocation()
  },
  {
    routes: ['Recommend', 'ReviewDestination', 'FeedbackForm'],
    redirectTo: 'PatientDetails',
    condition: () => !hasPatientInfo()
  },
  {
    routes: ['FeedbackForm'],
    redirectTo: 'ReviewDestination',
    condition: () => !store.getters['reputation/reviewType']
  },
  {
    routes: ['FeedbackForm'],
    redirectTo: 'Confirmation',
    condition: () => store.getters['reputation/submitted']
  },
  {
    routes: ['Confirmation'],
    redirectTo: 'LocationSelection',
    condition: () => !store.getters['reputation/submitted']
  }
]

router.beforeEach((to, from, next) => {
  for (const rule of GUARD_RULES) {
    if (rule.routes.includes(to.name) && rule.condition()) {
      return next({ name: rule.redirectTo, replace: true })
    }
  }
  next()
})

export default router
